module.exports = __webpack_public_path__ + "img/color-balance_cn.e9b4e61.jpg";